module.exports = __webpack_public_path__ + "static/media/dart-logo.178dcfc7.gif";